import { render } from "./ViewTable.vue?vue&type=template&id=9cf7066e"
import script from "./ViewTable.vue?vue&type=script&lang=js"
export * from "./ViewTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__